import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import EfEmarsysEmail from 'elem/ui/ef-emarsys-email';
import EfTitle from 'elem/ui/ef-title';
import EfModal from 'elem/ui/ef-modal';
import { useState } from 'react';

export default function TheComp() {
    const { t } = useLang('hat');
    const { locale = 'us' } = useRouter();
    const [showModal, setShowModal] = useState(false);

    // 格式化时间
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    const configs = {
        className: 'email-box',
        needTerms: true,
        tipsObj: {
            btnText: t('C_btn'),
            placeholder: t('C_placeholder'),
            tipsEmpty: 'Please enter the email.',
            tipsTypeError: 'Please enter a valid email address.',
            successTips: 'Subscription successful !',
            tipsFailed: 'Failed, please try again or contact us.',
        },
        isMulti: true,
        contactListId: ['1325946710'],
        fields: [
            {
                id: '11571',
                type: 'multiple',
                overwrite: false,
                value: [3],
            },
            {
                id: '4433',
                type: 'single',
                overwrite: true,
                value: 1,
            },
            {
                id: '9617',
                type: 'text',
                overwrite: true,
                value: dateString,
            },
            {
                id: '31',
                type: 'single',
                overwrite: true,
                value: 1,
            },
        ],
        callback: (statu: 'fail' | 'success') => {
            setShowModal(statu === 'success');
        },
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-s" />
            <EfTitle>{t('C_title')}</EfTitle>
            <div className="email-wrapper">
                <EfEmarsysEmail {...configs} />
                <svg className="mail-icon" xmlns="http://www.w3.org/2000/svg" width="27" height="21" viewBox="0 0 27 21" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23.2295 0.43634H3.8764C2.83591 0.43634 1.97041 0.764832 1.2799 1.42182C0.589391 2.0788 0.244141 2.88671 0.244141 3.84555V17.4824C0.244141 18.459 0.589391 19.2713 1.2799 19.9195C1.97041 20.5676 2.83591 20.8916 3.8764 20.8916H23.2295C24.27 20.8916 25.1355 20.5676 25.826 19.9195C26.5166 19.2713 26.8618 18.459 26.8618 17.4824V3.84555C26.8618 2.88671 26.5166 2.0788 25.826 1.42182C25.1355 0.764832 24.27 0.43634 23.2295 0.43634ZM3.87656 2.72585H23.2297C23.4756 2.72585 23.6885 2.77912 23.8682 2.88565C24.0479 2.99219 24.204 3.16088 24.3364 3.39171L13.5531 10.4498L2.76985 3.39171C2.90228 3.16088 3.05835 2.99219 3.23807 2.88565C3.4178 2.77912 3.63062 2.72585 3.87656 2.72585ZM23.2304 18.6289H3.87721C3.49885 18.6289 3.20089 18.5268 2.98334 18.3226C2.76578 18.1184 2.657 17.8387 2.657 17.4836V6.00412L12.816 12.716C12.9484 12.7693 13.0761 12.8225 13.1991 12.8758C13.322 12.9291 13.4403 12.9557 13.5538 12.9557C13.6673 12.9557 13.7855 12.9291 13.9085 12.8758C14.0315 12.8225 14.1592 12.7693 14.2916 12.716L24.4506 6.00412V17.4836C24.4506 17.8387 24.3418 18.1184 24.1242 18.3226C23.9067 18.5268 23.6087 18.6289 23.2304 18.6289Z"
                        fill="#919191"
                    />
                </svg>
            </div>
            {showModal && (
                <EfModal open={showModal} title="" position="center" callback={() => setShowModal(false)}>
                    <p className="modal-title">{t('C_success_title')}</p>
                    <p className="modal-desc">{t('C_success_desc')}</p>
                </EfModal>
            )}
        </div>
    );
}
